import { Box, Typography } from '@mui/material';

export default function PageHeader({ titulo, acoes }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 5,
            height: 26,
            borderRadius: 3,
            backgroundColor: '#e94560',
            flexShrink: 0,
          }}
        />
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: '#1a1a2e',
            lineHeight: 1.2,
          }}
        >
          {titulo}
        </Typography>
      </Box>

      {acoes && (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {acoes}
        </Box>
      )}
    </Box>
  );
}